import * as Service from '@/App/Service';
import ChalkySticks from '@chalkysticks/sdk';
import Store from '@/Store';

/**
 * Setup geolocation with permission handling.
 * Requires alertPromptRef for permission dialogs.
 *
 * @param any alertPromptRef
 * @return Promise<void>
 */
export async function setup(alertPromptRef: any): Promise<void> {
	const canUseLocation = Store.getters['settings/canUseLocation'];
	const locationDenied = Store.getters['settings/locationDenied'];
	const onboardingComplete = Store.getters['settings/onboardingComplete'];

	// Start services automatically if permitted
	if (canUseLocation) {
		Service.Location.start();
	}

	// User might have denied it, ask them again
	else if (onboardingComplete && locationDenied) {
		const result = await alertPromptRef.confirm(
			'Location is required for most features. Would you like to enable it now?',
			'Enable Location',
		);

		alertPromptRef.close();

		if (result) {
			// Wait for permissions
			await ChalkySticks.Utility.Geolocation.requestLocation();

			// Start regardless
			Service.Location.start();

			// Setup the settings
			Store.dispatch('settings/enableLocation', true);
			Store.commit('settings/setLocationDenied', false);
		}
	}

	ChalkySticks.Utility.Log.info('app', 'Geolocation setup complete');
}
